import React, { useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { usePromos } from "../context/promos";
import { auth } from "../services/firebase/firebase";
import PromosCard from "./promosCard";

const UserPromos = () => {
    const [user] = useAuthState(auth)
    const [loading, setLoading] = useState(false)
    const { promos } = usePromos()

    const filteredPromos = () => {
        if (!promos || promos?.length < 1) return []
        const newPromos = promos.filter(p => p.users.includes(user.email) || p.users.length < 1)
        return newPromos
    }

    return (
        <div className="bg-white" style={{ minHeight: '100%' }}>
            <div className="container p-4">
                <h2>Promociones</h2>
                <div className="row no-glutters p-4">
                    {loading ?
                        <div className="center">
                            <div className="text-center">
                                <div className="spinner-border" role="status" style={{ color: '#beb495', width: '75px', height: '75px' }}>
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="row no-glutters">
                            {filteredPromos().length < 1 && <p>Por el momento no hay promociones disponibles</p>}
                            {filteredPromos()?.map((promo, i) => (
                                <div key={`event-${i}`} className="col-sm-12 col-md-12 mb-2 d-flex flex-row justify-content-center">
                                    <PromosCard promo={promo} />
                                </div>
                            ))}
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default UserPromos;